import { store } from '@betacrew/jars-flux'
import { put, all, takeLatest } from 'redux-saga/effects';
import { addNotifications } from '../../toaster/ToasterPortalSlice';
import { TOASTER_VARIANT } from '../../../components/toast/constants';
import { componentKey, setDropDownOptions, setExportFile, setGridData, setGridTotal, setHeaders, setLoadingState, setMultiSelectdropDownOptions, setSecondaryDropDownOptions, setSelectedDropDownOption, setSelectedSecondaryDropDownOptions, setUSPSAmount, setPayrollStateList, setFormList } from './ReportSlice';
import Payer from '../../../../libs/utility/Payer';
import ReportDataService from '../../../../services/ReportDataService';
import PayerDataService from '../../../../services/PayerDataService';
import GeneralDataService from '../../../../services/GeneralDataService';
import ManageFormsService from '../../../../services/ManageFormsService';
import { ALL_SELECTED, REPORT_LOADING_STATES } from '../constants';
import General from '../../../../libs/utility/General';

export const { getOptInEmailStatusGridExport, USPSMailTORecipient, getUSPSAmount, getW9EmailStatusGrid, updateEmailId, getOptInEmailStatusGrid, getW9CopyStatusReportExport, getFederalTaxYears, get1099VendorCopyeDeliveryExport, get1099VendorCopyeDeliveryGrid, getQBOVendorHistoryReportExport, getQBOVendorHistoryReportGridData, getInvoiceReport, getDeliveryHeader, getFormDeliveryReport, getForms, getStateSubmissionHistoryReport, getSubmissionHistoryReport, getTaxYears, getUnsubmittedFormsGridData, getUnsubmittedFormsReport, getOptInReportHeader, getOPTINReport, getW8Report, getW8ReportHeader, getW9Report, getW9ReportHeader, getTINReport, getTinReportHeader, getPayerReportHeader, getPayerReport, getPayerReportByUserHeader, getPayerReportByUser, getMemberUser, getPayersList, getRecipientReport, getRecipientHeader, getPaymentsReceiptsReportExport, getStatePayrollReportStates, getStatePayrollReportForms, getStatePayrollSubmissionHistoryReport  } = {
    getPayerReportHeader: (payload) => {
        return {
            type: "REPORT/GET_PAYER_HEADER",
            payload: payload
        }
    },
    getPayerReport: (payload) => {
        return {
            type: "REPORT/GET_PAYER_REPORT",
            payload: payload
        }
    },
    getPayerReportByUserHeader: (payload) => {
        return {
            type: "REPORT/GET_PAYER_HEADER_BY_USER",
            payload: payload
        }
    },
    getPayerReportByUser: (payload) => {
        return {
            type: "REPORT/GET_PAYER_REPORT_BY_USER",
            payload: payload
        }
    },
    getMemberUser: (payload) => {
        return {
            type: "REPORT/GET_MEMBER_USER",
            payload: payload
        }
    },
    getPayersList: (payload) => {
        return {
            type: "REPORT/GET_PAYERS_LIST",
            payload: payload
        }
    },
    getRecipientReport: (payload) => {
        return {
            type: "REPORT/GET_RECIPIENT_REPORT",
            payload: payload
        }
    },
    getRecipientHeader: (payload) => {
        return {
            type: "REPORT/GET_RECIPIENT_HEADER",
            payload: payload
        }
    },
    getTINReport: (payload) => {
        return {
            type: "REPORT/GET_TIN_REPORT",
            payload: payload
        }
    },
    getTinReportHeader: (payload) => {
        return {
            type: "REPORT/GET_TIN_REPORT_HEADERS",
            payload: payload
        }
    },
    getW9ReportHeader: (payload) => {
        return {
            type: "REPORT/GET_W9_REPORT_HEADER",
            payload: payload
        }
    },
    getW9Report: (payload) => {
        return {
            type: "REPORT/GET_W9_REPORT",
            payload: payload
        }
    },
    getW8ReportHeader: (payload) => {
        return {
            type: "REPORT/GET_W8_REPORT_HEADER",
            payload: payload
        }
    },
    getW8Report: (payload) => {
        return {
            type: "REPORT/GET_W8_REPORT",
            payload: payload
        }
    },
    getOptInReportHeader: (payload) => {
        return {
            type: "REPORT/GET_OPTIN_REPORT_HEADER",
            payload: payload
        }
    },
    getOPTINReport: (payload) => {
        return {
            type: "REPORT/GET_OPTIN_REPORT",
            payload: payload
        }
    },
    getUnsubmittedFormsGridData: (payload) => {
        return {
            type: "REPORT/GET_UNSUBMITTED_FORMS_GRID_DATA",
            payload: payload
        }
    },
    getUnsubmittedFormsReport: (payload) => {
        return {
            type: "REPORT/GET_UNSUBMITTED_FORMS_REPORT",
            payload: payload
        }
    },
    getTaxYears: (payload) => {
        return {
            type: "REPORT/GET_TAX_YEARS",
            payload: payload
        }
    },
    getFederalTaxYears: (payload) => {
        return {
            type: "REPORT/GET_FEDERAL_TAX_YEARS",
            payload: payload
        }
    },
    getSubmissionHistoryReport: (payload) => {
        return {
            type: "REPORT/GET_SUBMISSION_HISTORY_REPORT",
            payload: payload
        }
    },
    getStateSubmissionHistoryReport: (payload) => {
        return {
            type: "REPORT/GET_STATE_SUBMISSION_HISTORY_REPORT",
            payload: payload
        }
    },
    getForms: (payload) => {
        return {
            type: "REPORT/GET_FORMS",
            payload: payload
        }
    },
    getFormDeliveryReport: (payload) => {
        return {
            type: "REPORT/GET_FORM_DELIVERY_REPORT",
            payload: payload
        }
    },
    getDeliveryHeader: (payload) => {
        return {
            type: "REPORT/GET_DELIVERY_HEADER",
            payload: payload
        }
    },
    getInvoiceReport: (payload) => {
        return {
            type: "REPORT/GET_INVOICE_REPORT",
            payload: payload
        }
    },
    getQBOVendorHistoryReportGridData: (payload) => {
        return {
            type: "REPORT/GET_QBO_VENDOR_HISTORY_REPORT",
            payload: payload
        }
    },
    getQBOVendorHistoryReportExport: (payload) => {
        return {
            type: "REPORT/GET_QBO_VENDOR_HISTORY_REPORT_EXPORT",
            payload: payload
        }
    },
    get1099VendorCopyeDeliveryGrid: (payload) => {
        return {
            type: "REPORT/GET_VENDOR_COPY_EDELIVERY_GRID_DATA",
            payload: payload
        }
    },
    getW9EmailStatusGrid: (payload) => {
        return {
            type: "REPORT/GET_W9_EMAIL_STATUS_GRID",
            payload: payload
        }
    },
    get1099VendorCopyeDeliveryExport: (payload) => {
        return {
            type: "REPORT/GET_VENDOR_COPY_EDELIVERY_EXPORT",
            payload: payload
        }
    },
    getW9CopyStatusReportExport: (payload) => {
        return {
            type: "REPORT/GET_W9_COPY_STATUS_EXPORT",
            payload: payload
        }
    },
    getOptInEmailStatusGrid: (payload) => {
        return {
            type: "REPORT/GET_OPT_IN_EMAIL_REPORT",
            payload: payload
        }
    },
    getOptInEmailStatusGridExport: (payload) => {
        return {
            type: "REPORT/GET_OPT_IN_EMAIL_REPORT_EXPORT",
            payload: payload
        }
    },
    updateEmailId: (payload) => {
        return {
            type: "REPORT/UPDATE_EMAIL_ID",
            payload: payload
        }
    },
    getUSPSAmount: (payload) => {
        return {
            type: "REPORT/GET_USPS_AMOUNT",
            payload: payload
        }
    },
    USPSMailTORecipient: (payload) => {
        return {
            type: "REPORT/USPS_MAIL_TO_RECIPIENT",
            payload: payload
        }
    },
    getPaymentsReceiptsReportExport: (payload) => {
        return {
            type: "REPORT/GET_PAYMENT_RECIPTS_REPORT_EXPORT",
            payload: payload
        }
    },
    getStatePayrollReportStates: (payload) => {
        return {
            type: "REPORT/GET_STATES",
            payload
        }
    },
    getStatePayrollReportForms: (payload) => {
        return {
            type: "REPORT/GET_FORMS",
            payload
        }
    },
    getStatePayrollSubmissionHistoryReport: (payload) => {
        return {
            type: "REPORT/GET_PAYROLL_STATE_SUBMISSION_HISTORY_REPORT",
            payload: payload
        }
    },
}

function* getPayerReportHeaderAsync() {
    try {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.HEADERS_LOADING }));
        const response = yield ReportDataService.getHeadersForPayerReport();
        if (response?.data?.Status && response.data.Status === 1) {
            yield put(setHeaders(response.data.Data.map(header => ({ label: header.Label, key: header.Name, value: false }))));
        }
        else {
            yield put(addNotifications({
                heading: "Error",
                message: response.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.HEADERS_READY }));
    }
}

function* getPayerReportAsync(action) {
    try {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.REPORT_RUN_LOADING }));
        const response = yield ReportDataService.downloadPayerReport(action.payload);

        if (response?.data?.Status && response.data.Status === 1) {
            yield put(setExportFile(response.data.Data));
        }
        else {
            yield put(addNotifications({
                heading: "Error",
                message: response.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.REPORT_RUN_READY }));
    }
}

function* getPayerReportByUserHeaderAsync() {
    try {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.HEADERS_LOADING }));
        const response = yield ReportDataService.getHeadersForPayerReport();
        if (response?.data?.Status && response.data.Status === 1) {
            yield put(setHeaders(response.data.Data.map(header => ({ label: header.Label, key: header.Name, value: false }))));
        }
        else {
            yield put(addNotifications({
                heading: "Error",
                message: response.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.HEADERS_READY }));
    }
}

function* getPayerReportByUserAsync(action) {
    try {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.REPORT_RUN_LOADING }));
        const response = yield ReportDataService.downloadPayerByUserReport(action.payload);

        if (response?.data?.Status && response.data.Status === 1) {
            yield put(setExportFile(response.data.Data));
        }
        else {
            yield put(addNotifications({
                heading: "Error",
                message: response.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.REPORT_RUN_READY }));
    }
}

function* getMemberUserAsync(action) {
    try {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.FILTER_LOADING }));
        const params = {
            PageNumber: 1,
            PageSize: 20,
            FilterText: action.payload,
            IsDesc: true
        }

        const response = yield PayerDataService.getMemberUsers(params);
        if (response?.data?.Status && response.data.Status === 1) {
            yield put(setDropDownOptions([{ label: ALL_SELECTED, value: ALL_SELECTED }, ...response.data.Data.map(member => ({ label: `${member.FirstName ?? ""} ${member.LastName ?? ""}`, value: member.UserId }))]))
        }
        else {
            yield put(addNotifications({
                heading: "Error",
                message: response.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.FILTER_READY }))
    }
}

function* getPayersListAsync(action) {
    try {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.FILTER_LOADING }));
        const isMultiSelect = action.payload?.isMultiSelect;
        const isSingleSelect = action.payload?.isSingleSelect;

        const response = yield PayerDataService.getPayersList();
        if (response?.data?.Status && response.data.Status === 1) {
            if (isMultiSelect || isMultiSelect === undefined) {
                yield put(setMultiSelectdropDownOptions([{ label: ALL_SELECTED, value: ALL_SELECTED, checked: false }, ...response.data.Data.map(member => ({ label: `${member.FirstName ?? ""} ${member.LastName ?? ""}`.trim(), value: member.PayerDetailId, checked: false }))]))
            }
            if (isSingleSelect) {
                yield put(setDropDownOptions([...response.data.Data.map(member => ({ label: `${member.FirstName ?? ""} ${member.LastName ?? ""}`.trim(), value: member.PayerDetailId }))]))
                const member = response.data.Data[0]
                yield put(setSelectedDropDownOption({ label: `${member.FirstName ?? ""} ${member.LastName ?? ""}`, value: member.PayerDetailId }))
            }
        }
        else {
            yield put(addNotifications({
                heading: "Error",
                message: response.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.FILTER_READY }))
    }
}

function* getRecipientReportAsync(action) {
    try {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.REPORT_RUN_LOADING }));
        const response = yield ReportDataService.downloadRecipientReport(action.payload);

        if (response?.data?.Status && response.data.Status === 1) {
            yield put(setExportFile(response.data.Data));
        }
        else {
            yield put(addNotifications({
                heading: "Error",
                message: response.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.REPORT_RUN_READY }));
    }
}

function* getRecipientHeaderAsync() {
    try {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.HEADERS_LOADING }));
        const response = yield ReportDataService.getHeadersForRecipientReport();
        if (response?.data?.Status && response.data.Status === 1) {
            yield put(setHeaders(response.data.Data.map(header => ({ label: header.Label, key: header.Name, value: false }))));
        }
        else {
            yield put(addNotifications({
                heading: "Error",
                message: response.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.HEADERS_READY }));
    }
}

function* getTinReportHeaderAsync() {
    try {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.HEADERS_LOADING }));
        const response = yield ReportDataService.getHeadersForTinReport();
        if (response?.data?.Status && response.data.Status === 1) {
            yield put(setHeaders(response.data.Data.map(header => ({ label: header.Label, key: header.Name, value: false }))));
        }
        else {
            yield put(addNotifications({
                heading: "Error",
                message: response.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.HEADERS_READY }));
    }
}

function* getTINReportAsync(action) {
    try {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.REPORT_RUN_LOADING }));
        const response = yield ReportDataService.downloadTinReport(action.payload);

        if (response?.data?.Status && response.data.Status === 1) {
            yield put(setExportFile(response.data.Data));
        }
        else {
            yield put(addNotifications({
                heading: "Error",
                message: response.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.REPORT_RUN_READY }));
    }
}

function* getW9ReportAsync(action) {
    try {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.REPORT_RUN_LOADING }));
        const response = yield ReportDataService.downloadW9Report(action.payload);

        if (response?.data?.Status && response.data.Status === 1) {
            yield put(setExportFile(response.data.Data));
        }
        else {
            yield put(addNotifications({
                heading: "Error",
                message: response.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.REPORT_RUN_READY }));
    }
}

function* getW9ReportHeaderAsync() {
    try {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.HEADERS_LOADING }));
        const response = yield ReportDataService.getHeadersForW9Report();
        if (response?.data?.Status && response.data.Status === 1) {
            yield put(setHeaders(response.data.Data.map(header => ({ label: header.Label, key: header.Name, value: false }))));
        }
        else {
            yield put(addNotifications({
                heading: "Error",
                message: response.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.HEADERS_READY }));
    }
}

function* getW8ReportHeaderAsync() {
    try {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.HEADERS_LOADING }));
        const response = yield ReportDataService.getHeadersForW8Report();
        if (response?.data?.Status && response.data.Status === 1) {
            yield put(setHeaders(response.data.Data.map(header => ({ label: header.Label, key: header.Name, value: false }))));
        }
        else {
            yield put(addNotifications({
                heading: "Error",
                message: response.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.HEADERS_READY }));
    }
}

function* getW8ReportAsync(action) {
    try {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.REPORT_RUN_LOADING }));
        const response = yield ReportDataService.downloadW8Report(action.payload);

        if (response?.data?.Status && response.data.Status === 1) {
            yield put(setExportFile(response.data.Data));
        }
        else {
            yield put(addNotifications({
                heading: "Error",
                message: response.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.REPORT_RUN_READY }));
    }
}

function* getOPTINReportAsync(action) {
    try {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.REPORT_RUN_LOADING }));
        const response = yield ReportDataService.downloadOptInReport(action.payload);

        if (response?.data?.Status && response.data.Status === 1) {
            yield put(setExportFile(response.data.Data));
        }
        else {
            yield put(addNotifications({
                heading: "Error",
                message: response.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.REPORT_RUN_READY }));
    }
}

function* getOptInReportHeaderAsync() {
    try {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.HEADERS_LOADING }));
        const response = yield ReportDataService.getHeadersForOPTReport();
        if (response?.data?.Status && response.data.Status === 1) {
            yield put(setHeaders(response.data.Data.map(header => ({ label: header.Label, key: header.Name, value: false }))));
        }
        else {
            yield put(addNotifications({
                heading: "Error",
                message: response.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.HEADERS_READY }));
    }
}

function* getUnsubmittedFormsReportAsync(action) {
    try {
        const { payerId, fromDate, toDate, taxYear, IsAllPayers } = action.payload;
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.REPORT_RUN_LOADING }));

        const param = {
            payerId: payerId || 0,
            fromDate,
            toDate,
            taxYear,
            IsAllPayers
        }

        const response = yield ReportDataService.getDataUnsubmittedFormsReportExport(param);
        if (response?.data?.Status && response.data.Status === 1) {
            const total = General.extractPaginationTotalFromResponse(response.data)
            yield put(setExportFile(General.extractDataFromResponseData(response.data)));
        }
        else {
            yield put(addNotifications({
                heading: "Error",
                message: response.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.REPORT_RUN_READY }));
    }
}


function* getUnsubmittedFormsGridDataAsync(action) {
    try {
        const { rowsPerPage, payerId, fromDate, toDate, taxYear, skip } = action.payload;
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.GRID_READY }));

        const param = {
            PageNumber: (skip / rowsPerPage) + 1,
            PageSize: rowsPerPage,
            payerId: payerId || 0,
            fromDate,
            toDate,
            taxYear
        }

        const response = yield ReportDataService.getDataUnsubmittedFormsReport(param);

        if (response?.data?.Status && response.data.Status === 1) {
            const total = General.extractPaginationTotalFromResponse(response.data)
            yield put(setGridData(General.extractDataFromResponseData(response.data)))
            yield put(setGridTotal(total))
        }
        else {
            yield put(addNotifications({
                heading: "Error",
                message: response.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.GRID_READY }));
    }
}

function* getTaxYearsAsync() {
    try {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.FILTER_LOADING }));
        const response = yield GeneralDataService.get94xTaxYears();

        if (response?.data?.Status && response.data.Status === 1) {
            const years = response.data.Data.map(data => ({ label: data.ID, value: data.ID }))
            yield put(setSecondaryDropDownOptions(years));
            yield put(setSelectedSecondaryDropDownOptions(years[0]));
        }
        else {
            yield put(addNotifications({
                heading: "Error",
                message: response.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.FILTER_READY }))
    }
}

function* getFederalTaxYearsAsync() {
    try {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.FILTER_LOADING }));
        const response = yield GeneralDataService.getTaxYears();

        if (response?.data?.Status && response.data.Status === 1) {
            const years = response.data.Data.map(data => ({ label: data.ID, value: data.ID }))
            yield put(setSecondaryDropDownOptions(years));
            yield put(setSelectedSecondaryDropDownOptions(years[0]));
        }
        else {
            yield put(addNotifications({
                heading: "Error",
                message: response.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.FILTER_READY }))
    }
}

function* getSubmissionHistoryReportAsync(action) {
    try {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.REPORT_RUN_LOADING }));
        const response = yield ReportDataService.getSubmissionHistoryReport(action.payload);

        if (response?.data?.Status && response.data.Status === 1) {
            yield put(setExportFile(response.data.Data));
        }
        else {
            yield put(addNotifications({
                heading: "Error",
                message: response.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.REPORT_RUN_READY }));
    }
}

function* getStateSubmissionHistoryReportAsync(action) {
    try {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.REPORT_RUN_LOADING }));
        const response = yield ReportDataService.getStateSubmissionHistoryReport(action.payload);

        if (response?.data?.Status && response.data.Status === 1) {
            yield put(setExportFile(response.data.Data));
        }
        else {
            yield put(addNotifications({
                heading: "Error",
                message: response.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.REPORT_RUN_READY }));
    }
}

function* getFormsAsync() {
    try {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.FILTER_LOADING }));
        const response = yield ManageFormsService.getStateForms();

        if (response?.data?.Status && response.data.Status === 1) {
            const form = response.data.Data.map(data => ({ label: data.FormName1, value: data.FormId }))
            yield put(setSecondaryDropDownOptions(form));
            yield put(setSelectedSecondaryDropDownOptions(form[0]));
        }
        else {
            yield put(addNotifications({
                heading: "Error",
                message: response.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.FILTER_READY }))
    }
}

function* getQBOVendorHistoryReportGridDataAsync(action) {
    try {
        const { rowsPerPage, skip } = action.payload;

        yield put(setLoadingState({ state: REPORT_LOADING_STATES.GRID_LOADING }));
        const param = {
            PageNumber: (skip / rowsPerPage) + 1,
            PageSize: rowsPerPage,
        }
        const response = yield ReportDataService.getQBOVendorHistoryReportGridData(param);

        if (response?.data?.Status && response.data.Status === 1) {
            const total = General.extractPaginationTotalFromResponse(response.data)
            yield put(setGridData(General.extractDataFromResponseData(response.data)));
            yield put(setGridTotal(total));
        }
        else {
            yield put(addNotifications({
                heading: "Error",
                message: response.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.GRID_READY }));
    }
}

function* getQBOVendorHistoryReportExportAsync() {
    try {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.REPORT_RUN_LOADING }));

        const response = yield ReportDataService.getQBOVendorHistoryReportGridExport();

        if (response?.data?.Status && response.data.Status === 1) {
            yield put(setExportFile(response.data.Data));
        }
        else {
            yield put(addNotifications({
                heading: "Error",
                message: response.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.REPORT_RUN_READY }));
    }
}

function* getFormDeliveryReportAsync(action) {
    try {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.REPORT_RUN_LOADING }));
        const response = yield ReportDataService.downloadFormsDeliveryReport(action.payload);

        if (response?.data?.Status && response.data.Status === 1) {
            yield put(setExportFile(response.data.Data));
        }
        else {
            yield put(addNotifications({
                heading: "Error",
                message: response.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.REPORT_RUN_READY }));
    }
}

function* getDeliveryHeaderAsync() {
    try {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.HEADERS_LOADING }));
        const response = yield ReportDataService.getHeadersFormsDeliveryReport();
        if (response?.data?.Status && response.data.Status === 1) {
            yield put(setHeaders(response.data.Data.map(header => ({ label: header.Label, key: header.Name, value: false }))));
        }
        else {
            yield put(addNotifications({
                heading: "Error",
                message: response.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.HEADERS_READY }));
    }
}

function* getInvoiceReportAsync(action) {
    try {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.REPORT_RUN_LOADING }));
        const response = yield ReportDataService.getInvoiceReport(action.payload);
        if (response?.data?.Status && response.data.Status === 1) {
            yield put(addNotifications({
                heading: "Success",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.SUCCESS
            }));
        }
        else {
            yield put(addNotifications({
                heading: "Error",
                message: response.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.REPORT_RUN_READY }));
    }
}

function* getW9EmailStatusGridAsync(action) {
    try {

        const { PayerId, skip, rowsPerPage } = action.payload;
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.GRID_LOADING }));

        const param = {
            PageNumber: (skip / rowsPerPage) + 1,
            PageSize: rowsPerPage,
            PayerId: PayerId || 0,
            IsDesc: ''
        }

        const response = yield ReportDataService.getW9EmailStatusGrid(param);

        if (response?.data?.Status && response.data.Status === 1) {
            const total = General.extractPaginationTotalFromResponse(response.data)
            yield put(setGridData(General.extractDataFromResponseData(response.data)))
            yield put(setGridTotal(total))
        }
        else {
            yield put(addNotifications({
                heading: "Error",
                message: response.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.GRID_READY }));
    }
}

function* get1099VendorCopyeDeliveryGridAsync(action) {
    try {

        const { PayerId, taxYear, skip, rowsPerPage } = action.payload;
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.GRID_LOADING }));

        const param = {
            PageNumber: (skip / rowsPerPage) + 1,
            PageSize: rowsPerPage,
            PayerId: PayerId || 0,
            taxYear,
            IsDesc: ''
        }

        const response = yield ReportDataService.get1099VendorCopyeDeliveryGrid(param);

        if (response?.data?.Status && response.data.Status === 1) {
            const total = General.extractPaginationTotalFromResponse(response.data)
            yield put(setGridData(General.extractDataFromResponseData(response.data)))
            yield put(setGridTotal(total))
        }
        else {
            yield put(addNotifications({
                heading: "Error",
                message: response.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.GRID_READY }));
    }
}

function* getOptInEmailStatusGridAsync(action) {
    try {

        const { PayerId, taxYear, skip, rowsPerPage } = action.payload;
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.GRID_LOADING }));

        const param = {
            PageNumber: (skip / rowsPerPage) + 1,
            PageSize: rowsPerPage,
            PayerId: PayerId || 0,
            taxYear,
            IsDesc: ''
        }

        const response = yield ReportDataService.getOptInEmailStatusGrid(param);

        if (response?.data?.Status && response.data.Status === 1) {
            const total = General.extractPaginationTotalFromResponse(response.data)
            yield put(setGridData(General.extractDataFromResponseData(response.data)))
            yield put(setGridTotal(total))
        }
        else {
            yield put(addNotifications({
                heading: "Error",
                message: response.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.GRID_READY }));
    }
}

function* updateEmailIdAsync(action) {
    try {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.UPDATE_EMAIL_LOADING }));
        const { data, callbackFn } = action.payload;
        const response = yield ReportDataService.updateEmailId(data);

        if (response?.data?.Status && response.data.Status === 1) {
            yield put(addNotifications({
                heading: "Success",
                message: response.data.Message,
                variant: TOASTER_VARIANT.SUCCESS
            }));
            callbackFn()
        }
        else {
            yield put(addNotifications({
                heading: "Error",
                message: response.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.UPDATE_EMAIL_READY }))
    }
}

function* get1099VendorCopyeDeliveryExportAsync(action) {
    try {

        const { PayerId, taxYear, skip, rowsPerPage } = action.payload;
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.REPORT_RUN_LOADING }));

        const param = {
            PageNumber: (skip / rowsPerPage) + 1,
            PageSize: rowsPerPage,
            PayerId: PayerId || 0,
            taxYear,
        }

        const response = yield ReportDataService.get1099VendorCopyeDeliveryGridExport(param);

        if (response?.data?.Status && response.data.Status === 1) {
            yield put(setExportFile(response.data.Data));
        }
        else {
            yield put(addNotifications({
                heading: "Error",
                message: response.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.REPORT_RUN_READY }));
    }
}

function* getW9CopyStatusReportExportAsync(action) {
    try {

        const { PayerId } = action.payload;
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.REPORT_RUN_LOADING }));

        const param = {
            PayerId: PayerId || 0,
        }

        const response = yield ReportDataService.getW9CopyStatusReportExport(param);

        if (response?.data?.Status && response.data.Status === 1) {
            yield put(setExportFile(response.data.Data));
        }
        else {
            yield put(addNotifications({
                heading: "Error",
                message: response.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.REPORT_RUN_READY }));
    }
}

function* getOptInEmailStatusGridExportAsync(action) {
    try {

        const { PayerId } = action.payload;
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.REPORT_RUN_LOADING }));

        const param = {
            PayerId: PayerId || 0,
        }

        const response = yield ReportDataService.getOptInStatusReporExport(param);

        if (response?.data?.Status && response.data.Status === 1) {
            yield put(setExportFile(response.data.Data));
        }
        else {
            yield put(addNotifications({
                heading: "Error",
                message: response.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.REPORT_RUN_READY }));
    }
}

function* getUSPSAmountAsync(action) {
    try {

        yield put(setLoadingState({ state: REPORT_LOADING_STATES.SECONDARY_ACTION_LOADING }));

        const response = yield ReportDataService.getUSPSAmount(action.payload);

        if (response?.data?.Status && response.data.Status === 1) {
            yield put(setUSPSAmount(response.data.Data));
        }
        else {
            yield put(addNotifications({
                heading: "Error",
                message: response.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.SECONDARY_ACTION_READY }));
    }
}

function* USPSMailTORecipientAsync(action) {
    try {

        yield put(setLoadingState({ state: REPORT_LOADING_STATES.SECONDARY_ACTION_LOADING }));

        const response = yield ReportDataService.getUSPSAmount(action.payload);

        if (response?.data?.Status && response.data.Status === 1) {
            yield put(setUSPSAmount(response.data.Data));
        }
        else {
            yield put(addNotifications({
                heading: "Error",
                message: response.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.SECONDARY_ACTION_READY }));
    }
}

function* getPaymentsReceiptsReportExportAsync(action) {
    try {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.REPORT_RUN_LOADING }));

        const param = action.payload

        const response = yield ReportDataService.getPaymentsReceiptsReport(param);

        if (response.data) {
            if (response?.data?.Status && response.data.Status === 1) {
                if(response?.data?.Data){
                    yield put(setExportFile(response.data.Data));
                }else{
                    yield put(addNotifications({
                        heading: "Error",
                        message: response.data?.Message,
                        variant: TOASTER_VARIANT.DANGER
                    }));
                }
            }
            else {
                yield put(addNotifications({
                    heading: "Error",
                    message: response.data?.Message,
                    variant: TOASTER_VARIANT.DANGER
                }));
            }
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: REPORT_LOADING_STATES.REPORT_RUN_READY }));
    }
}

function* getStatePayrollReportStatesAsync() {
    try {
        const response = yield ReportDataService.getStatePayrollStateNames();
        const { Message, Status, Data } = response?.data;
        if (Status === 1 && Data) {
            if (Data?.StateNames) {
                const stateList = [...Data.StateNames];
                General.addOptionAndValueKeys(stateList, "StateName", "StateName");
                yield all([
                    put(setPayrollStateList(stateList)),
                ]);

            } else {
                yield put(addNotifications({ heading: "Error", message: "States not found" }));
            }
        } else {
            yield put(addNotifications({ heading: "Error", message: Message }));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
    }
}
function* getStatePayrollReportFormsAsync(action) {
    try {
        const params = action.payload.stateNames;
        const response = yield ReportDataService.getStatePayrollFormNames(params)
        const { Message, Status, Data } = response?.data;
        if (Status === 1) {
            if (Data) {
                General.addOptionAndValueKeys(Data, "FormName1", "FormId");
                yield put(setFormList(Data));
            }
            else {
                yield put(addNotifications({ heading: "Error", message: "Forms not found" }));
            }
        } else {
            yield put(addNotifications({ heading: "Error", message: Message }));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
    }
}
function* getStatePayrollSubmissionHistoryReportAsync(action) {
    try {
        const { formLabel, fromDate, toDate } = action.payload;
        const response = yield ReportDataService.getDownloadStatePayrollHistory(formLabel, fromDate, toDate);
        const { Message, Status, Data } = response?.data;

        if (Status === 1) {
            if (Data) {
                yield put(setExportFile(Data));
            }
            else {
                yield put(addNotifications({ heading: "Error", message: "Data not found" }));
            }
        }
        else {
            yield put(addNotifications({ heading: "Error", message: Message }));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    }
}
function* rootSaga() {
    yield all([
        takeLatest(getPayerReportHeader().type, getPayerReportHeaderAsync),
        takeLatest(getPayerReport().type, getPayerReportAsync),
        takeLatest(getPayerReportByUserHeader().type, getPayerReportByUserHeaderAsync),
        takeLatest(getPayerReportByUser().type, getPayerReportByUserAsync),
        takeLatest(getMemberUser().type, getMemberUserAsync),
        takeLatest(getPayersList().type, getPayersListAsync),
        takeLatest(getRecipientReport().type, getRecipientReportAsync),
        takeLatest(getRecipientHeader().type, getRecipientHeaderAsync),
        takeLatest(getTinReportHeader().type, getTinReportHeaderAsync),
        takeLatest(getTINReport().type, getTINReportAsync),
        takeLatest(getW9ReportHeader().type, getW9ReportHeaderAsync),
        takeLatest(getW9Report().type, getW9ReportAsync),
        takeLatest(getW8ReportHeader().type, getW8ReportHeaderAsync),
        takeLatest(getW8Report().type, getW8ReportAsync),
        takeLatest(getOptInReportHeader().type, getOptInReportHeaderAsync),
        takeLatest(getOPTINReport().type, getOPTINReportAsync),
        takeLatest(getUnsubmittedFormsGridData().type, getUnsubmittedFormsGridDataAsync),
        takeLatest(getUnsubmittedFormsReport().type, getUnsubmittedFormsReportAsync),
        takeLatest(getTaxYears().type, getTaxYearsAsync),
        takeLatest(getFederalTaxYears().type, getFederalTaxYearsAsync),
        takeLatest(getSubmissionHistoryReport().type, getSubmissionHistoryReportAsync),
        takeLatest(getStateSubmissionHistoryReport().type, getStateSubmissionHistoryReportAsync),
        takeLatest(getForms().type, getFormsAsync),
        takeLatest(getFormDeliveryReport().type, getFormDeliveryReportAsync),
        takeLatest(getDeliveryHeader().type, getDeliveryHeaderAsync),
        takeLatest(getInvoiceReport().type, getInvoiceReportAsync),
        takeLatest(getQBOVendorHistoryReportGridData().type, getQBOVendorHistoryReportGridDataAsync),
        takeLatest(getQBOVendorHistoryReportExport().type, getQBOVendorHistoryReportExportAsync),
        takeLatest(get1099VendorCopyeDeliveryGrid().type, get1099VendorCopyeDeliveryGridAsync),
        takeLatest(getOptInEmailStatusGrid().type, getOptInEmailStatusGridAsync),
        takeLatest(get1099VendorCopyeDeliveryExport().type, get1099VendorCopyeDeliveryExportAsync),
        takeLatest(getW9CopyStatusReportExport().type, getW9CopyStatusReportExportAsync),
        takeLatest(getOptInEmailStatusGridExport().type, getOptInEmailStatusGridExportAsync),
        takeLatest(getOptInEmailStatusGrid().type, getOptInEmailStatusGridAsync),
        takeLatest(updateEmailId().type, updateEmailIdAsync),
        takeLatest(getW9EmailStatusGrid().type, getW9EmailStatusGridAsync),
        takeLatest(getUSPSAmount().type, getUSPSAmountAsync),
        takeLatest(USPSMailTORecipient().type, USPSMailTORecipientAsync),
        takeLatest(getPaymentsReceiptsReportExport().type, getPaymentsReceiptsReportExportAsync),
        takeLatest(getStatePayrollReportStates().type, getStatePayrollReportStatesAsync),
        takeLatest(getStatePayrollReportForms().type, getStatePayrollReportFormsAsync),
        takeLatest(getStatePayrollSubmissionHistoryReport().type, getStatePayrollSubmissionHistoryReportAsync)
    ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);